import { io } from 'socket.io-client';

let socket = null;

export function initSocket(token = null) {
  // If socket exists and is connected, return it
  if (socket?.connected) {
    console.log('[Socket] Already connected:', socket.id);
    return socket;
  }

  // If socket exists but disconnected, try to reconnect
  if (socket && !socket.connected) {
    console.log('[Socket] Reconnecting...');
    socket.connect();
    return socket;
  }

  // Create new socket
  console.log('[Socket] Creating new connection...');
  socket = io({
    transports: ['websocket', 'polling'],
    auth: token ? { token } : {},
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  });

  socket.on('connect', () => {
    console.log('[Socket] Connected:', socket.id);
  });

  socket.on('disconnect', (reason) => {
    console.log('[Socket] Disconnected:', reason);
  });

  socket.on('connect_error', (error) => {
    console.error('[Socket] Connection error:', error.message);
  });

  return socket;
}

export function getSocket() {
  // If socket doesn't exist or is disconnected, initialize it
  if (!socket || !socket.connected) {
    return initSocket();
  }
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

// Helper for promisified emit with callback
export function emitAsync(event, data = {}) {
  return new Promise((resolve, reject) => {
    if (!socket) {
      reject(new Error('Socket not initialized'));
      return;
    }

    const timeout = setTimeout(() => {
      reject(new Error('Socket timeout'));
    }, 10000);

    socket.emit(event, data, (response) => {
      clearTimeout(timeout);
      if (response.success) {
        resolve(response);
      } else {
        reject(new Error(response.error || 'Unknown error'));
      }
    });
  });
}
